import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Eleicao } from '../models/eleicao.model';
import { Injectable } from '@angular/core';
import { Email } from '../models/email.model';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  configHeader: any;

  constructor(
    private http: HttpClient
    ) { }
    
  public listarPorIdEleicao(idEleicao: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get(`${environment.url_api}/emailContent/eleicao/${idEleicao}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    })
  }
  public salvarEmailEleicao(email: Email, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/emailContent`, email, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }
  public editarEmailEleicao(idEmail: number, email: Email, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.put(`${environment.url_api}/emailContent/${idEmail}`, email, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }  
}
